import { BlockError } from '@/blocks.04-project/block-error/block-error';
import debounce from 'lodash-es/debounce';
import throttle from 'lodash-es/throttle';

/***
 Класс шапки страницы
 @example
 Переменные:
 --header-height {number + px, default=null} - размер верхней шапки
 --header-offset-top {number + px, default=null} - отступ по размеру верхней шапки
 --header-offset-bottom {number + px, default=null} - отступ по размеру нижней шапки
 */
class Header {
  /***
   * Конструктор класса
   * @param elem {HTMLElement} DOM элемент с классом header
   */
  constructor(elem) {
    this.BlockError = new BlockError({ blockName: 'Header', destroy: this.destroy });
    if (!elem) return this.BlockError.error('Отсутствует elem');

    this.block = elem;
    this.block.Header = this;
    this.lastScroll = window.scrollY;
    this.init();
  }

  init = () => {
    this.bottomNav = this.block.querySelector('.header__bottom-control');
    if (!this.bottomNav) return this.BlockError.error('Отсутствует .header__bottom-control');

    this.innerContainer = this.block.querySelector('.header__inner');
    if (!this.innerContainer) return this.BlockError.error('Отсутствует .header__inner');

    this.searchContainer = this.block.querySelector('.header__search');
    if (!this.searchContainer) return this.BlockError.error('Отсутствует .header__search');

    this.static = this.block.classList.contains('header_static');

    this.updateOffsets();
    if (!this.static) this.setObserver();

    this.searchContainer.addEventListener('transitionend', this.transitionEndHandler);
    window.addEventListener('resize', this.debounceResize,{passive: true} );
    this.debounceResize();
    this.block.classList.add('header_inited');
  };

  transitionEndHandler = (event) => {
    if (event.propertyName === 'height') this.updateOffsets();
  };

  debounceResize = debounce(() => {
    this.updateOffsets();
    window.removeEventListener('scroll', this.throttleScroll);
    if (window.screen.width < 992) {
      window.addEventListener('scroll', this.throttleScroll, {passive: true});
    }
  }, 300);

  throttleScroll = throttle(() => {
    this.innerContainer.classList.toggle('header_hide', window.scrollY > this.lastScroll);
    this.lastScroll = window.scrollY;
  }, 300);

  updateOffsets = () => {
    this.offsetBottom = this.getOffsetBottom();
    this.headerHeight = this.getHeaderHeight();
    this.offsetTop = this.getOffsetTop();

    document.body.style.setProperty('--header-height', this.headerHeight + 'px');
    document.body.style.setProperty('--header-offset-top', this.offsetTop + 'px');
    document.body.style.setProperty('--header-offset-bottom', this.offsetBottom + 'px');
  };

  getOffsetTop = () => {
    return this.static ? 0 : this.getHeaderHeight();
  };

  getHeaderHeight = () => {
    return this.innerContainer.offsetHeight;
  };

  getOffsetBottom = () => {
    return this.bottomNav.offsetHeight;
  };

  setObserver = () => {
    const callbackFunction = (entries) => {
      entries.forEach(entry => {
        this.block.classList.toggle('header_sticky', (entry.isIntersecting === false && entry.intersectionRatio === 0));
      });
      this.updateOffsets();
    };

    this.observer = new IntersectionObserver(callbackFunction);
    this.observer.observe(this.block);
  };

  destroy = () => {
    if (this.searchContainer) this.searchContainer.removeEventListener('transitionend', this.transitionEndHandler);
    if (this.observer) this.observer.disconnect();
    if (this.block) {
      this.block.classList.remove('header_inited');
      delete this.block.Header;
    }
  };

  static init() {
    Array.from(document.querySelectorAll('.header:not(.header_inited)')).forEach((elem) => new Header(elem));
  }
}

document.addEventListener('DOMContentLoaded', Header.init);

// Экспорт;
window.Block.Header = Header;
